import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f37424d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SingleProductDetails" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleBox" }, /*#__PURE__*/_toDisplayString("基础信息"), -1))
const _hoisted_3 = {
  class: "centerBox",
  style: {"background":"#fff","border-radius":"4px"}
}
const _hoisted_4 = {
  class: "row",
  style: {"width":"100%"}
}
const _hoisted_5 = { style: {"position":"relative"} }
const _hoisted_6 = {
  key: 0,
  class: "tipsBox"
}
const _hoisted_7 = { style: {"position":"relative"} }
const _hoisted_8 = {
  key: 0,
  class: "tipsBox"
}
const _hoisted_9 = { class: "formItem" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "innerText",
  style: {"position":"absolute","right":"0px","bottom":"5px","z-index":"99","color":"#ccc"}
}, "mm", -1))
const _hoisted_12 = { class: "innerText" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "innerText",
  style: {"position":"absolute","right":"0px","bottom":"5px","z-index":"99","color":"#ccc"}
}, "mm", -1))
const _hoisted_14 = { class: "innerText" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "innerText",
  style: {"position":"absolute","right":"0px","bottom":"5px","z-index":"99","color":"#ccc"}
}, "mm", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "innerText",
  style: {"position":"absolute","left":"50px","bottom":"5px","z-index":"99"}
}, "mm", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "innerText",
  style: {"position":"absolute","left":"50px","bottom":"5px","z-index":"99"}
}, "mm", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "innerText",
  style: {"position":"absolute","left":"50px","bottom":"5px","z-index":"99"}
}, "mm", -1))
const _hoisted_20 = { class: "upload-text" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "点击上传", -1))
const _hoisted_22 = {
  key: 1,
  class: "imgBox"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_24 = { class: "editBox" }
const _hoisted_25 = {
  key: 0,
  style: {"margin-left":"12px","color":"#999"}
}
const _hoisted_26 = {
  key: 0,
  class: "span"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "支持PNG或JPG格式，大小应小于5M", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Form_item = _resolveComponent("Form-item")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_NobrandTips = _resolveComponent("NobrandTips")!
  const _component_BrandSelect = _resolveComponent("BrandSelect")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_PictureOutlined = _resolveComponent("PictureOutlined")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_Image = _resolveComponent("Image")!
  const _component_EyeFilled = _resolveComponent("EyeFilled")!
  const _component_EditFilled = _resolveComponent("EditFilled")!
  const _component_Custom = _resolveComponent("Custom")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BrandModal = _resolveComponent("BrandModal")!
  const _component_CategroyModal = _resolveComponent("CategroyModal")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      model: _ctx.formState,
      rules: _ctx.rules,
      ref: "formRef",
      "label-col": { style: { width: '100px' } }
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Form_item, {
            label: "单品名称",
            name: "spName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.spName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.spName) = $event)),
                placeholder: 
              !_ctx.todoEdit
                ? ''
                : '品牌+[功能/特性/口味]+类别+规格+[包装形式/货号] 例：蒙牛高钙奶粉200g'
            ,
                disabled: !_ctx.todoEdit,
                class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
              }, null, 8, ["value", "placeholder", "disabled", "class"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "单品编码",
            name: "spCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.spCode,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.spCode) = $event)),
                placeholder: "默认系统自动生成",
                disabled: "",
                class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
              }, null, 8, ["value", "class"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "单品条形码",
            name: "spBarCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.spBarCode,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.spBarCode) = $event)),
                placeholder: "请输入",
                disabled: !_ctx.todoEdit,
                class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
              }, null, 8, ["value", "disabled", "class"])
            ]),
            _: 1
          }),
          _createVNode(_component_Form_item, {
            label: "单品简称",
            name: "spNickName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.spNickName,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.spNickName) = $event)),
                placeholder: !_ctx.todoEdit ? '' : '请输入',
                disabled: !_ctx.todoEdit,
                class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
              }, null, 8, ["value", "placeholder", "disabled", "class"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Form_item, {
              label: "单位",
              name: "stockUnitCode",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Select, {
                  value: _ctx.formState.stockUnitCode,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.stockUnitCode) = $event)),
                  style: {"width":"100%"},
                  disabled: !_ctx.todoEdit,
                  class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder'),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listBaseValue, (item, index) => {
                      return (_openBlock(), _createBlock(_component_Option, {
                        key: index,
                        value: item.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "disabled", "class"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form_item, {
              label: "品类",
              name: "categoryName"
            }, {
              default: _withCtx(() => [
                (_ctx.showUnclassified)
                  ? (_openBlock(), _createBlock(_component_Input, {
                      key: 0,
                      value: _ctx.formState.categoryName,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.categoryName) = $event)),
                      placeholder: "请至少选择一个品类",
                      onClick: _ctx.changeUnclassified,
                      autocomplete: "off",
                      disabled: !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "onClick", "disabled", "class"]))
                  : (_openBlock(), _createBlock(_component_CategorySelect, {
                      key: 1,
                      ref: "CategorySelect",
                      formState: _ctx.formState,
                      style: {"width":"100%"},
                      class: "cascader"
                    }, null, 8, ["formState"]))
              ]),
              _: 1
            }),
            (_ctx.todoEdit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_NobrandTips, {
                    title: "品类",
                    path: "/category"
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Form_item, {
              label: "品牌",
              name: "brandName"
            }, {
              default: _withCtx(() => [
                (_ctx.brandUnclassified)
                  ? (_openBlock(), _createBlock(_component_Input, {
                      key: 0,
                      value: _ctx.formState.brandName,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.brandName) = $event)),
                      placeholder: "请至少选择一个品牌",
                      onClick: _ctx.changeBrandUnclassified,
                      autocomplete: "off",
                      disabled: !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "onClick", "disabled", "class"]))
                  : (_openBlock(), _createBlock(_component_BrandSelect, {
                      key: 1,
                      ref: "brandSelect",
                      formState: _ctx.formState,
                      class: "cascader2",
                      style: {"width":"100%"}
                    }, null, 8, ["formState"]))
              ]),
              _: 1
            }),
            (_ctx.todoEdit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_NobrandTips, {
                    title: "品牌",
                    path: "/brand"
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", {
              class: _normalizeClass(["money", _ctx.todoEdit ? '' : 'noBoder'])
            }, "￥", 2),
            _createVNode(_component_Form_item, {
              label: "零售价",
              name: "salesPrice"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Input, {
                  value: _ctx.formState.salesPrice,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.salesPrice) = $event)),
                  placeholder: !_ctx.todoEdit ? '' : '请输入',
                  disabled: !_ctx.todoEdit,
                  class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                }, null, 8, ["value", "placeholder", "disabled", "class"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_Form_item, {
            label: "保质期",
            name: "shelfLife",
            style: {"position":"relative"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Input, {
                value: _ctx.formState.shelfLife,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.shelfLife) = $event)),
                placeholder: !_ctx.todoEdit ? '' : '请输入',
                style: {"width":"100%"},
                disabled: !_ctx.todoEdit,
                class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
              }, null, 8, ["value", "placeholder", "disabled", "class"]),
              _createElementVNode("span", {
                class: _normalizeClass(["innerText day", _ctx.todoEdit ? '' : 'noBoder']),
                style: {"position":"absolute","right":"0px","bottom":"5px","z-index":"99","color":"#ccc"}
              }, "天", 2)
            ]),
            _: 1
          }),
          (_ctx.todoEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_Form_item, {
                  label: "包装尺寸",
                  name: "sizeLong",
                  style: {"position":"relative"},
                  disabled: !_ctx.todoEdit,
                  class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      value: _ctx.formState.sizeLong,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.sizeLong) = $event)),
                      placeholder: "长度",
                      disabled: !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "disabled", "class"]),
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["disabled", "class"]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_CloseOutlined, { class: "closeOutlined" })
                ]),
                _createVNode(_component_Form_item, {
                  label: "",
                  name: "sizeWide",
                  style: {"position":"relative"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      value: _ctx.formState.sizeWide,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.sizeWide) = $event)),
                      placeholder: "宽度",
                      disabled: !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "disabled", "class"]),
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_CloseOutlined, { class: "closeOutlined" })
                ]),
                _createVNode(_component_Form_item, {
                  label: "",
                  name: "sizeHigh",
                  style: {"position":"relative"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      value: _ctx.formState.sizeHigh,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.sizeHigh) = $event)),
                      placeholder: "高度",
                      disabled: !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "disabled", "class"]),
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_Form_item, {
                  label: "长度",
                  name: "sizeLong",
                  style: {"position":"relative"},
                  disabled: !_ctx.todoEdit,
                  class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      value: _ctx.formState.sizeLong,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.sizeLong) = $event)),
                      disabled: !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "disabled", "class"]),
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["disabled", "class"]),
                _createVNode(_component_Form_item, {
                  label: "宽度",
                  name: "sizeWide",
                  style: {"position":"relative"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      value: _ctx.formState.sizeWide,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formState.sizeWide) = $event)),
                      placeholder: "",
                      disabled: !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "disabled", "class"]),
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_Form_item, {
                  label: "高度",
                  name: "sizeHigh",
                  style: {"position":"relative"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Input, {
                      value: _ctx.formState.sizeHigh,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formState.sizeHigh) = $event)),
                      placeholder: "",
                      disabled: !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "disabled", "class"]),
                    _hoisted_19
                  ]),
                  _: 1
                })
              ])),
          _createVNode(_component_Form_item, {
            label: "单品图片",
            name: ""
          }, {
            default: _withCtx(() => [
              (_ctx.imgFlag && _ctx.notUploaded)
                ? (_openBlock(), _createBlock(_component_Upload, {
                    key: 0,
                    name: "file",
                    "list-type": "picture-card",
                    onChange: _ctx.handleChange,
                    "before-upload": _ctx.beforeUpload,
                    customRequest: _ctx.customRequest,
                    "file-list": _ctx.filelist,
                    "onUpdate:file-list": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filelist) = $event)),
                    showUploadList: false,
                    disabled: !_ctx.todoEdit
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_PictureOutlined, { style: {"font-size":"20px"} }),
                        _hoisted_21
                      ])
                    ]),
                    _: 1
                  }, 8, ["onChange", "before-upload", "customRequest", "file-list", "disabled"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_Image, {
                      style: {"width":"240px","height":"160px","object-fit":"cover"},
                      src: _ctx.firstImg || _ctx.formState.imgUrl,
                      class: "previewPhoto"
                    }, null, 8, ["src"]),
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", {
                        class: "span",
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.previewImg && _ctx.previewImg(...args)))
                      }, [
                        _createVNode(_component_EyeFilled),
                        _createTextVNode(" 查看 ")
                      ]),
                      (_ctx.todoEdit)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "|"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Upload, {
                        class: "notUpload",
                        "file-list": _ctx.filelist,
                        "onUpdate:file-list": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filelist) = $event)),
                        name: "file",
                        onChange: _ctx.handleChange,
                        "before-upload": _ctx.beforeUpload,
                        customRequest: _ctx.customRequest,
                        showUploadList: false,
                        disabled: !_ctx.todoEdit
                      }, {
                        default: _withCtx(() => [
                          (_ctx.todoEdit)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                _createVNode(_component_EditFilled),
                                _createTextVNode(" 编辑 ")
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["file-list", "onChange", "before-upload", "customRequest", "disabled"])
                    ])
                  ])),
              _hoisted_27
            ]),
            _: 1
          })
        ]),
        (_ctx.showCustom)
          ? (_openBlock(), _createBlock(_component_Custom, {
              key: 0,
              datalist: _ctx.formState,
              todoEdit: _ctx.todoEdit
            }, null, 8, ["datalist", "todoEdit"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Form_item, {
          "wrapper-col": { span: 14, offset: 10 },
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"margin-right":"20px","width":"100px","height":"40px"},
              onClick: _ctx.cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.todoEdit)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  style: {"width":"100px","height":"40px"},
                  type: "primary",
                  onClick: _ctx.onSubmit,
                  loading: this.$store.state.loadingStatus
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_BrandModal, {
          ref: "brandModal",
          onMyevent: _cache[18] || (_cache[18] = ($event: any) => (_ctx.reloadCategroyBrand('brand')))
        }, null, 512),
        _createVNode(_component_CategroyModal, {
          ref: "CategroyModal",
          onMyevent: _cache[19] || (_cache[19] = ($event: any) => (_ctx.reloadCategroyBrand('categroy')))
        }, null, 512)
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}